module.exports = __webpack_public_path__ + "img/filter_open.a4947bb1.svg";